import { CartAddEvent } from '@theme/events';

  document.querySelectorAll(".cart-item__gift").forEach((cartItem) => {
    const variantSelect = cartItem.querySelector(".variant-select");
    const giftButton = cartItem.querySelector(".button--gift");

    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        const selectedOption = variantSelect.selectedOptions[0];
        const selectedVariantID = selectedOption.getAttribute("value");
        giftButton.setAttribute("data-gift-id", selectedVariantID);
      });
    }

    giftButton.addEventListener("click", function (event) {
      event.preventDefault();
      const variantID = giftButton.getAttribute("data-gift-id");
      addItem(variantID);
    });
  });

function addItem(variantID) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      quantity: 1,
      id: variantID,
    }),
  })
    .then((response) => {
      if (response.ok) {
        // Dispatch CartAddEvent to trigger cart update without refresh
        const cartAddEvent = new CartAddEvent(
          {}, // resource (cart object)
          'gwp-cart', // sourceId
          {
            variantId: variantID,
            source: 'gwp-cart',
            itemCount: 1, // You might want to get actual cart count
            sections: {} // You might want to specify which sections to update
          }
        );
        document.dispatchEvent(cartAddEvent);
      } else {
        console.error("Failed to add item to the cart");
      }
    })
    .catch((error) => console.error(error));
}

function showTab(category) {
	const tabs = document.querySelectorAll('.nav-tabs__link');
	const normalizedCategory = category.toLowerCase().replace(/\s+/g, '');
	const tabItems = document.querySelectorAll('.nav-tabs__item');
	const tabsExist = tabs.length > 0;
  
	// Set active tab
	tabs.forEach((tab) => {
	  tab.classList.toggle('active', tab.textContent.toLowerCase().replace(/\s+/g, '') === normalizedCategory);
	});
  
	// Filter tabs
	tabItems.forEach((tabItem) => {
	  const shouldDisplay = !tabsExist || tabItem.classList.contains(normalizedCategory);
	  tabItem.style.display = shouldDisplay ? 'block' : 'none';
	});
}

// Make showTab globally accessible
window.showTab = showTab;
  
function navTabs() {
	const firstTabText = document.querySelector('.nav-tabs__link')?.textContent || '';
	showTab(firstTabText);
}

function klaviyo_form_trigger() {
  document.querySelectorAll('.klaviyo_form_trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const K_id_trigger = this.dataset.kpopupid;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', K_id_trigger]);
    });
  });
}

function accordionNew() {
  // Helper function to close all panels in the current accordion list
  function closeAllPanels(accordionItems, excludeItem = null) {
      accordionItems.forEach((item) => {
          if (item !== excludeItem) {
              const panel = item.querySelector('.af-accordion_panel');
              const head = item.querySelector('.af-accordion_head');
              head.classList.remove('active');
              panel.classList.remove('active');
              panel.style.maxHeight = null;  // Collapse the panel
          }
      });
  }

  // Initialize all accordions (including nested ones)
  const accordions = document.querySelectorAll('.af-accordion_list');

  accordions.forEach((accordion, accordionIndex) => {
      const accordionItems = accordion.querySelectorAll(':scope > .af-accordion_item'); // Scope to current accordion level only

      // On first load, open the first accordion item in the parent list
      if (accordionIndex === 0 && accordionItems.length > 0) {
          const firstItem = accordionItems[0];
          const firstHead = firstItem.querySelector('.af-accordion_head');
          const firstPanel = firstItem.querySelector('.af-accordion_panel');

          firstHead.classList.add('active');
          firstPanel.classList.add('active');
          firstPanel.style.maxHeight = firstPanel.scrollHeight + 'px';  // Set height based on content
      }

      accordionItems.forEach((item) => {
          const head = item.querySelector('.af-accordion_head');

          head.addEventListener('click', function(event) {
              // Prevent nested accordion clicks from affecting parent accordion
              event.stopPropagation();

              const panel = head.nextElementSibling;
              const isActive = head.classList.contains('active');

              // If the clicked accordion head is already active (open), close it
              if (isActive) {
                  head.classList.remove('active');
                  panel.classList.remove('active');
                  panel.style.maxHeight = null; // Collapse panel
              } else {
                  // Close all panels in the current accordion list, except the clicked one
                  closeAllPanels(accordionItems, item);

                  // If not active, open this one
                  head.classList.add('active');
                  panel.classList.add('active');
                  panel.style.maxHeight = panel.scrollHeight + 'px'; // Set height based on content
              }
          });
      });
  });
}

function Tab() {
  const tabContainers = document.querySelectorAll(".tab-container");
  if (!tabContainers.length) return;

  /**
   * Add click events to tab headers
   */
  function addTabHeaderEvents() {
    tabContainers.forEach((container) => {
      const tabHeaders = container.querySelectorAll(".tab-header");

      tabHeaders.forEach((header) => {
        header.addEventListener("click", () => {
          const contentId = header.dataset.tabcontentid;
          const selectedContent = container.querySelector(`#${contentId}`);
          const accordionPanel = container.closest(".af-accordion_panel.active");

          // Reset all tabs
          tabHeaders.forEach((h) => h.classList.remove("selected"));
          container.querySelectorAll(".tab-content").forEach((c) => {
            c.style.display = "none";
          });

          // Activate selected tab
          header.classList.add("selected");
          if (selectedContent) selectedContent.style.display = "block";

          // Adjust accordion height
          if (accordionPanel && selectedContent) {
            const contentHeight = selectedContent.offsetHeight; // margin not included
            accordionPanel.style.maxHeight = contentHeight + 35 + "px";
          }
        });
      });
    });
  }

  /**
   * Add click events for select-tab triggers
   */
  function addSelectTabEvents() {
    const selectTabs = document.querySelectorAll(".select-tab");

    selectTabs.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const headerId = trigger.dataset.tabheaderid;
        const selectedHeader = document.getElementById(headerId);
        if (!selectedHeader) return;

        const container = selectedHeader.closest(".tab-container");
        if (!container) return;

        const contentId = selectedHeader.dataset.tabcontentid;
        const selectedContent = container.querySelector(`#${contentId}`);

        // Reset tabs
        container.querySelectorAll(".tab-header").forEach((h) => h.classList.remove("selected"));
        container.querySelectorAll(".tab-content").forEach((c) => (c.style.display = "none"));

        // Activate selected tab
        selectedHeader.classList.add("selected");
        if (selectedContent) selectedContent.style.display = "block";
      });
    });
  }

  addSelectTabEvents();
  addTabHeaderEvents();

  // Hide Vimeo text in product description
  document.querySelectorAll("#description-tab p").forEach((p) => {
    if (p.textContent.includes("vimeo")) {
      p.style.display = "none";
    }
  });
}

function pdpScroll(){
	const fixedColumn1 = document.querySelector('.product-information__media');
	const fixedColumn2 = document.querySelector('.product-details');

  
	const handleScroll = (column) => {
	  if (column.scrollTop + column.clientHeight >= column.scrollHeight) {
		// Calculate how much of the column content has been scrolled
		const overflowAmount = column.scrollTop + column.clientHeight - column.scrollHeight -100;
		// Scroll the body by the same amount
		window.scrollTo(0, overflowAmount);
	  }
	};
  
	fixedColumn1.addEventListener('scroll', function() {
	  handleScroll(fixedColumn1);
	});
  
	fixedColumn2.addEventListener('scroll', function() {
	  handleScroll(fixedColumn2);
	});
  
	window.addEventListener('scroll', function() {
	  if (window.scrollY === 0) {
		// When the body is scrolled to the top, enable column scrolling again
		if (fixedColumn2.scrollTop + fixedColumn2.clientHeight >= fixedColumn2.scrollHeight) {
		  fixedColumn2.scrollTop = fixedColumn2.scrollHeight - fixedColumn2.clientHeight;
		} else if (fixedColumn1.scrollTop + fixedColumn1.clientHeight >= fixedColumn1.scrollHeight) {
		  fixedColumn1.scrollTop = fixedColumn1.scrollHeight - fixedColumn1.clientHeight;
		}
	  }
	});
};

document.addEventListener('DOMContentLoaded', function() {
	navTabs();
  accordionNew();
  Tab();

  /*if (document.querySelector('.template-product')) {
    pdpScroll();
  }*/
});
